import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  GalaxyFilterChipDependencies,
  GalaxyFilterDefinitionInterface,
  GalaxyFilterInterface,
  GalaxyFilterType,
  GalaxyFilterOperator,
} from '@vendasta/galaxy/filter/chips';
import { TranslateService } from '@ngx-translate/core';
import { OwnerType, OwnerInfo } from '@vendasta/email-builder';

@Injectable({ providedIn: 'root' })
export class EmailTemplateFilterService implements GalaxyFilterChipDependencies {
  private readonly translate = inject(TranslateService);
  private readonly sourceLabel = this.translate.instant('EMAILS.TEMPLATES.FILTER.SOURCE');
  private readonly featuredLabel = this.translate.instant('EMAILS.TEMPLATES.FILTER.FEATURED');
  private readonly myLabel = this.translate.instant('EMAILS.TEMPLATES.FILTER.MY');

  listObjectFilters(_searchTerm: string): Observable<GalaxyFilterDefinitionInterface[]> {
    return of([
      {
        fieldId: 'templateOwner',
        fieldName: this.sourceLabel,
        type: GalaxyFilterType.FILTER_TYPE_STRING,
        hasFilterOptions: true,
        supportedOperators: [GalaxyFilterOperator.FILTER_OPERATOR_IS],
        preset: true,
      },
    ]);
  }

  getFieldOptions(_fieldId: string, _search: string): Observable<string[]> {
    return of([this.featuredLabel, this.myLabel]);
  }

  resolveOwners(filters: GalaxyFilterInterface[], namespace: string): OwnerInfo[] {
    const ownerFilter = filters.find((f) => f.fieldId === 'templateOwner');

    if (!ownerFilter?.values?.length) {
      // No filter selected: return both owners
      return [
        { ownerType: OwnerType.OWNER_TYPE_SYSTEM, ownerId: 'SYSTEM-SMB' },
        { ownerType: OwnerType.OWNER_TYPE_ACCOUNT_GROUP, ownerId: namespace },
      ] as OwnerInfo[];
    }

    const selectedValues = ownerFilter.values.map((v) => v.string).filter((s): s is string => !!s);

    const owners = [] as OwnerInfo[];
    if (selectedValues.includes(this.featuredLabel)) {
      owners.push({ ownerType: OwnerType.OWNER_TYPE_SYSTEM, ownerId: 'SYSTEM-SMB' } as OwnerInfo);
    }
    if (selectedValues.includes(this.myLabel)) {
      owners.push({ ownerType: OwnerType.OWNER_TYPE_ACCOUNT_GROUP, ownerId: namespace } as OwnerInfo);
    }

    return owners;
  }
}
